export const whyMyfitsocietyData = {
    en: {
        title: "Why Myfitsociety?",
        button: 'Get Special Offer',
        content: [
            "Achieve your ideal body from the comfort of your home",
            "Get real result with quick & effective workout",
            "Made for everyone, from beginner to advance",
            "Reduce stress, get better sleep & feel energized everyday",
            "Social & gamification to keep you motivated"
        ],
        slide: {
            desktop: [
                "/static/new-landing-page/why-myfitsociety/desktop/en/1.webp",
                "/static/new-landing-page/why-myfitsociety/desktop/2.webp",
                "/static/new-landing-page/why-myfitsociety/desktop/en/3.webp",
                "/static/new-landing-page/why-myfitsociety/desktop/en/4.webp",
                "/static/new-landing-page/why-myfitsociety/desktop/en/5.webp"
            ],
            mobile: [
                "/static/new-landing-page/why-myfitsociety/mobile/en/1.webp",
                "/static/new-landing-page/why-myfitsociety/mobile/en/2.webp",
                "/static/new-landing-page/why-myfitsociety/mobile/en/3.webp",
                "/static/new-landing-page/why-myfitsociety/mobile/en/4.webp",
                "/static/new-landing-page/why-myfitsociety/mobile/en/5.webp"
            ]
        }
    },
    id: {
        title: "Mengapa Myfitsociety?",
        button: 'Dapatkan Penawaran Spesial',
        content: [
            "Raih tubuh idealmu hanya dari rumah",
            "Dapatkan hasil nyata dengan olahraga singkat & efektif",
            "Dibuat untuk semua orang, dari pemula hingga ahli",
            "Kurangi stres, tidur lebih nyenyak & merasa berenergi",
            "Komunitas & gamifikasi membantu kamu tetap termotivasi"
        ],
        slide: {
            desktop: [
                "/static/new-landing-page/why-myfitsociety/desktop/id/1.webp",
                "/static/new-landing-page/why-myfitsociety/desktop/2.webp",
                "/static/new-landing-page/why-myfitsociety/desktop/id/3.webp",
                "/static/new-landing-page/why-myfitsociety/desktop/id/4.webp",
                "/static/new-landing-page/why-myfitsociety/desktop/id/5.webp"
            ],
            mobile: [
                "/static/new-landing-page/why-myfitsociety/mobile/id/1.webp",
                "/static/new-landing-page/why-myfitsociety/mobile/id/2.webp",
                "/static/new-landing-page/why-myfitsociety/mobile/id/3.webp",
                "/static/new-landing-page/why-myfitsociety/mobile/id/4.webp",
                "/static/new-landing-page/why-myfitsociety/mobile/id/5.webp"
            ]
        }
    }
}

export const workoutPlanData = {
    en: {
        title1: "Discover the perfect workout & diet program ",
        title2: "tailored to your goals",
        button: 'Find Your Program',
        tab: [
            {
                key: 'bodyweight',
                title: 'Bodyweight',
                desktopImage: '/static/new-landing-page/workout-plan/bodyweight/en/desktop_bodyweight_en.webp',
                mobileImage: '/static/new-landing-page/workout-plan/bodyweight/en/mobile_bodyweight_en.webp',
            },
            {
                key: 'running',
                title: 'Running',
                desktopImage: '/static/new-landing-page/workout-plan/run/en/desktop_run_en.webp',
                mobileImage: '/static/new-landing-page/workout-plan/run/en/mobile_run_en.webp',
            },
            {
                key: 'strength',
                title: 'Strength',
                desktopImage: '/static/new-landing-page/workout-plan/weights/en/desktop_weights_en.webp',
                mobileImage: '/static/new-landing-page/workout-plan/weights/en/mobile_weights_en.webp',
            },
            {
                key: 'yoga',
                title: 'Yoga',
                desktopImage: '/static/new-landing-page/workout-plan/yoga/en/desktop_yoga_en.webp',
                mobileImage: '/static/new-landing-page/workout-plan/yoga/en/mobile_yoga_en.webp',
            },
            {
                key: 'combat',
                title: 'Combat',
                desktopImage: '/static/new-landing-page/workout-plan/combat/en/desktop_combat_en.webp',
                mobileImage: '/static/new-landing-page/workout-plan/combat/en/mobile_combat_en.webp',
            },
        ]
    },
    id: {
        title1: "Temukan program olahraga & diet yang",
        title2: "sesuai dengan goalmu",
        button: 'Lihat Programnya',
        tab: [
            {
                key: 'bodyweight',
                title: 'Bodyweight',
                desktopImage: '/static/new-landing-page/workout-plan/bodyweight/id/desktop_bodyweight_id.webp',
                mobileImage: '/static/new-landing-page/workout-plan/bodyweight/id/mobile_bodyweight_id.webp',
            },
            {
                key: 'running',
                title: 'Lari',
                desktopImage: '/static/new-landing-page/workout-plan/run/id/desktop_run_id.webp',
                mobileImage: '/static/new-landing-page/workout-plan/run/id/mobile_run_id.webp',
            },
            {
                key: 'strength',
                title: 'Beban',
                desktopImage: '/static/new-landing-page/workout-plan/weights/id/desktop_weights_id.webp',
                mobileImage: '/static/new-landing-page/workout-plan/weights/id/mobile_weights_id.webp',
            },
            {
                key: 'yoga',
                title: 'Yoga',
                desktopImage: '/static/new-landing-page/workout-plan/yoga/id/desktop_yoga_id.webp',
                mobileImage: '/static/new-landing-page/workout-plan/yoga/id/mobile_yoga_id.webp',
            },
            {
                key: 'combat',
                title: 'Combat',
                desktopImage: '/static/new-landing-page/workout-plan/combat/id/desktop_combat_id.webp',
                mobileImage: '/static/new-landing-page/workout-plan/combat/id/mobile_combat_id.webp',
            },
        ]
    }
}

export const becomeMemberData = {
    en: {
        title: "Member Benefits",
        button: 'I\'m interested',
        content: [
            "Access 150+ workouts, from bodyweight, strength and yoga to running and combat.",
            "Scan meals instantly with AI and track nutrition in seconds.",
            "Get real-time advice from your Fit AI Coach & Nutritionist, 24/7.",
            "Cook with ease: 250+ quick, healthy recipes at your fingertips.",
            "Recharge with calming audio sessions and sleep soundscapes."
        ],
        slide: {
            mobile: [
                "/static/new-landing-page/become-member/mobile/1.webp",
                "/static/new-landing-page/become-member/mobile/en/2.webp",
                "/static/new-landing-page/become-member/mobile/en/3.webp",
                "/static/new-landing-page/become-member/mobile/en/4.webp",
                "/static/new-landing-page/become-member/mobile/en/5.webp",
            ],
            desktop: [
                "/static/new-landing-page/become-member/desktop/en/1.webp",
                "/static/new-landing-page/become-member/desktop/en/2.webp",
                "/static/new-landing-page/become-member/desktop/en/3.webp",
                "/static/new-landing-page/become-member/desktop/en/4.webp",
                "/static/new-landing-page/become-member/desktop/en/5.webp",
            ]
        }
    },
    id: {
        title: "Manfaat Menjadi Member",
        button: 'Saya Berminat',
        content: [
            "Akses 150+ olahraga, dari olahraga tanpa alat, olahraga beban, yoga, lari, dan combat.",
            "Foto makananmu dengan AI scanner dan dapatkan info nutrisi dalam hitungan detik.",
            "Konsultasi dengan AI Coach & Ahli Gizi kapan saja; 24 jam, 7 hari seminggu.",
            "Masak dengan mudah: Lebih dari 250 resep cepat dan sehat dalam genggamanmu.",
            "Lebih rileks dengan sesi audio yang menenangkan dan musik untuk tidur."
        ],
        slide: {
            mobile: [
                "/static/new-landing-page/become-member/mobile/1.webp",
                "/static/new-landing-page/become-member/mobile/id/2.webp",
                "/static/new-landing-page/become-member/mobile/id/3.webp",
                "/static/new-landing-page/become-member/mobile/id/4.webp",
                "/static/new-landing-page/become-member/mobile/id/5.webp",
            ],

            desktop: [
                "/static/new-landing-page/become-member/desktop/id/1.webp",
                "/static/new-landing-page/become-member/desktop/id/2.webp",
                "/static/new-landing-page/become-member/desktop/id/3.webp",
                "/static/new-landing-page/become-member/desktop/id/4.webp",
                "/static/new-landing-page/become-member/desktop/id/5.webp",
            ]
        }
    }
}

export const testimonyData = {
    en: [
        {
            name: "Syifa Ulya Syahidah",
            avatar: "/static/new-landing-page/testimony/syifa.webp",
            text: "It's a really cool app. It helps my diet and so far I have lost 22kg thanks to this app too. Thank you!"
        },
        {
            name: "Devikha V",
            avatar: "/static/new-landing-page/testimony/devikha_k.webp",
            text: "Losing weight has been a struggle for me & I don't really have time to commit to a gym membership. This app provides a lot of info and features, it's really easy to use and it has really help me."
        },
        {
            name: "Andri K",
            avatar: "/static/new-landing-page/testimony/andri_k.webp",
            text: "I managed to lose 10kg by following the exercise program and fitness tracker. I consider myself rather lazy and it's hard to be consistent, but using this app is really easy!"
        },
        {
            name: "Narendra Archie",
            avatar: "/static/new-landing-page/testimony/narendra.webp",
            text: "Comparing this to some other fitness app. This one gives you a more complete experience, with food nutritions, fit tracker, and of course, daily workouts. Great overall app."
        },
        {
            name: "Yosi Andris Tanti",
            avatar: "/static/new-landing-page/testimony/yosi.webp",
            text: "This app is really cool! It help me to have a workout during work from home situation and keeps me healthy and happy. You guys need to have it too!"
        }
    ],
    id: [
        {
            name: "Syifa Ulya Syahidah",
            avatar: "/static/new-landing-page/testimony/syifa.webp",
            text: "Keren banget sih aplikasinya. Bisa bantu diet aku dan sejauh ini udah lost 22kg berkat app ini juga. Thank you!"
        },
        {
            name: "Devikha V",
            avatar: "/static/new-landing-page/testimony/devikha_k.webp",
            text: "Menurunkan berat badan itu susah banget & gue tidak punya waktu untuk komit buat gym membership. App ini menyediakan banyak info & fitur, sangat mudah untuk digunakan dan sangat membantu gue."
        },
        {
            name: "Andri K",
            avatar: "/static/new-landing-page/testimony/andri_k.webp",
            text: "Gw berhasil turun 10kg dgn mengikuti program olahraga dan fitness trackernya. Gw termasuk orang yg males dan susah untuk konsisten, tapi pake apps ini jadi gampang banget!"
        },
        {
            name: "Narendra Archie",
            avatar: "/static/new-landing-page/testimony/narendra.webp",
            text: "Jika dibandingkan dengan beberapa aplikasi fitnes lainnya, aplikasi ini memberikan pengalaman yang lebih lengkap, termasuk informasi nutrisi makanan, fit tracker, dan tentu saja, olahraga harian. Overall aplikasi yang sangat bagus."
        },
        {
            name: "Yosi Andris Tanti",
            avatar: "/static/new-landing-page/testimony/yosi.webp",
            text: "Aplikasi ini benar-benar keren! Membantu gw untuk berolahraga selama bekerja dari rumah dan menjaga gw tetap sehat dan bahagia. Kalian juga harus punya aplikasi ini!"
        }
    ]
}

export const comparisonData = {
    en: {
        title: "Why We Are Better",
        description: "More complete features to help you achieve your ideal body faster and easier."
    },
    id: {
        title: "Mengapa Kami Lebih Baik",
        description: "Fitur lebih lengkap untuk membantu kamu mendapatkan badan ideal dengan lebih cepat dan mudah"
    }
}

export const planData = {
    en: {
        title: "Get Your Body Goals, Start Now!",
        limitedBogo: "Limited Time! Pay 1 Get 2",
        tncApply: "*Terms & Condition Pay 1 Get 2",
        plans: [
            {
                id: 1,
                save: "SAVE 22%",
                duration: "1 Month Subscription",
                promoLabel: "Promo - Pay 1 Get 2",
                originalPrice: "Rp125.000",
                discountedPrice: "Rp97.000",
                perMonth: "Rp48.500 / Person / Month",
                badge: null
            },
            {
                id: 3,
                save: "POPULAR - SAVE 60%",
                duration: "3 Months Subscription",
                promoLabel: "Promo - Pay 1 Get 2",
                originalPrice: "Rp375.000",
                discountedPrice: "Rp147.000",
                perMonth: "Rp24.500 / Person / Month",
                badge: "POPULAR"
            },
            {
                id: 6,
                save: "BEST - SAVE 73%",
                duration: "6 Months Subscription",
                promoLabel: "Promo - Pay 1 Get 2",
                originalPrice: "Rp750.000",
                discountedPrice: "Rp197.000",
                perMonth: "Rp16.450 / Person / Month",
                badge: "BEST"
            }
        ],
        productInfo: "*This is a digital product in the form of app subscriptions",
        minRequirement: "*Minimum Android 9 & IOS 13",
        guaranteeTitle: "30 Days Money Back Guarantee",
        guaranteeDescription: "We have confidence in the effectiveness of our plan. We are so committed that we offer a money-back guarantee if you do not see or feel results within 4 weeks and can demonstrate adherence to our plan. Please review our Refund Policy for complete details and requirements.",
        refundPolicy: "Terms & Conditions Apply",
        termsText: "By purchasing, you accept our Terms of Use and Privacy Policy.",
        termsOfUse: "Terms of Use",
        privacyPolicy: "Privacy Policy",
        buttonText: "Choose This Plan",
        perMonthLabel: "/month"
    },
    id: {
        title: "Dapatkan Body Goalsmu, Mulai Sekarang!",
        limitedBogo: "Waktu Terbatas! Beli 1 Dapat 2",
        tncApply: "*Syarat & Ketentuan Beli 1 Dapat 2",
        productInfo: "*Ini adalah produk digital berupa langganan aplikasi",
        minRequirement: "*Minimum Android 9 & IOS 13",
        guaranteeTitle: "Jaminan 30 Hari Uang Kembali",
        guaranteeDescription: "Kami percaya pada efektivitas program kami. Kami sangat berkomitmen sehingga menawarkan jaminan uang kembali jika Anda tidak melihat atau merasakan hasil dalam 4 minggu dan dapat menunjukkan kepatuhan terhadap program kami. Silakan tinjau Kebijakan Pengembalian Dana kami untuk detail dan persyaratan lengkap.",
        refundPolicy: "Syarat & Ketentuan Berlaku",
        termsText: "Dengan membeli, Anda menerima Syarat Penggunaan dan Kebijakan Privasi kami.",
        termsOfUse: "Syarat Penggunaan",
        privacyPolicy: "Kebijakan Privasi",
        buttonText: "Pilih Paket Ini",
        perMonthLabel: "/bulan"
    }
}

export const faqQuestionData = {
    id: [
        {
            question: "Apa bedanya sama aplikasi fitness gratisan di luar sana?",
            answer: "Beda banget! Kami buatkan program khusus untuk meraih goal kamu. Aplikasi gratisan seringkali cuma kasih video acak tanpa program yang jelas. Udah capek olahraga & diet, tidak dapat hasil, bahkan bisa cidera.\n\nKami juga nggak cuma kasih workout, tapi juga nutrisi, relaksasi, dan masih banyak lagi. Semua dalam satu app, tanpa bayar extra!"
        },
        {
            question: "Gimana kalau saya sibuk dan nggak punya banyak waktu?",
            answer: "Tenang, semua workout bisa disesuaikan sama jadwal kamu. Bahkan ada sesi 10–15 menit yang efektif banget. Cocok buat kamu yang kerja full-time tapi tetap mau sehat!"
        },
        {
            question: "Saya pemula banget, bisa nggak ikut program ini?",
            answer: "Cocok banget! Program kami dibuat untuk semua level, dari yang baru mulai sampai yang sudah ahli. Ada program khusus untuk pemula yang mudah diikuti. Kamu juga dapat akses ke AI coach yang siap membantu kamu 24 jam jika ada pertanyaan."
        },
        {
            question: "Kenapa harganya sangat terjangkau?",
            answer: "Kami menggabungkan program olahraga, panduan diet, pelacak kalori, AI Food Scanner, AI Coach, resep sehat, dan berbagai fitur premium lainnya dalam satu aplikasi untuk membantu pengguna mendapatkan hasil maksimal.\n\nJika menggunakan beberapa aplikasi berbeda untuk mendapatkan fitur serupa, total biayanya bisa jauh lebih mahal. Myfitsociety juga menjadi alternatif yang lebih praktis dan terjangkau dibandingkan mengikuti sesi personal trainer dan membayar membership gym secara terpisah."
        },
        {
            question: "Harus punya alat olahraga atau gym membership?",
            answer: "Nggak perlu sama sekali! Banyak banget pilihan workout yang bisa kamu lakuin di rumah tanpa alat apa pun. Cukup siapin niat, langsung bisa mulai!"
        },
        {
            question: "Saya udah coba banyak hal tapi gagal terus. Apakah ada garansi?",
            answer: "Ada banget! Kalau kamu ikutin programnya dengan benar tapi gak dapat hasil dalam 30 hari, kami akan refund pembayaran kamu. Kamu jadi gak ada resiko untuk mencoba! Untuk syarat lengkapnya klik disini ",
            answerLink: "Ketentuan Pengembalian Dana",
            answerLinkUrl: "/page/refund-policy"
        },
        {
            question: "Pembayarannya aman nggak?",
            answer: "Aman banget! Semua transaksi menggunakan payment gateway terpercaya."
        },
        {
            question: "Aplikasi ini bisa dipakai di HP apa aja?",
            answer: "Bisa dipakai di Android (min. versi 9) dan iPhone (min. iOS 13). Hampir semua HP zaman sekarang pasti bisa!"
        }
    ],
    en: [
        {
            question: "How is this different from all those free fitness apps out there?",
            answer: "Totally different! We create a personalized program designed specifically to help you reach your goals. Free apps often just give you random videos without any clear program. You end up working out and dieting with no results, or worse, risking injury. With us, you get more than just workouts: we've got nutrition, relaxation, and so much more. All in one app, no extra charges!"
        },
        {
            question: "What if I'm super busy and don't have much time?",
            answer: "No worries! Every workout can be tailored to fit your schedule. We even have super-effective 10–15 minute sessions, perfect if you're working full-time but still want to stay healthy!"
        },
        {
            question: "I'm a complete beginner. Is this program for me?",
            answer: "Absolutely! Our programs are designed for all fitness levels, from absolute beginners to advanced athletes. We have a special, easy-to-follow program just for beginners. Plus, you get 24/7 access to our AI coach, who's always there to help if you have any questions."
        },
        {
            question: "Why is it so affordable?",
            answer: "We combine workout programs, diet guidance, a calorie tracker, AI Food Scanner, AI Coach, healthy recipes, and many other premium features in one app to help users maximize their results.\n\nUsing several different apps to access similar features could cost significantly more. Myfitsociety is also a more practical and affordable alternative to paying separately for personal training sessions and a gym membership."
        },
        {
            question: "Do I need any equipment or a gym membership?",
            answer: "Not at all! We have tons of workout options you can do at home without any equipment. Just bring your motivation, and you're good to go!"
        },
        {
            question: "I've tried so many things and keep failing. Is there a guarantee?",
            answer: "Absolutely! If you follow the program correctly but don't see results within 30 days, we'll refund your payment. You've got nothing to lose by trying! For complete terms click here ",
            answerLink: "Refund Policy",
            answerLinkUrl: "/page/refund-policy"
        },
        {
            question: "Is the payment secure?",
            answer: "Totally secure! All transactions use trusted payment gateways."
        },
        {
            question: "What devices does the app work on?",
            answer: "It works on Android (minimum version 9) and iPhone (minimum iOS 13). Pretty much any modern phone will run it just fine!"
        }
    ]
}

export const testimonyAvatarSrcSet = (src) => src.endsWith('.webp') ? `${src.replace(/\.webp$/, '_72w.webp')} 72w, ${src} 150w` : undefined;
